import { render, staticRenderFns } from "./STabs.vue?vue&type=template&id=b3977710&scoped=true&class=container&"
import script from "./STabs.vue?vue&type=script&lang=js&"
export * from "./STabs.vue?vue&type=script&lang=js&"
import style0 from "./STabs.vue?vue&type=style&index=0&id=b3977710&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3977710",
  null
  
)

export default component.exports